import React from "react";
import CustomTable from "../components/CustomTable/CustomTable";

const customTableCookiesMarketing = (
  <CustomTable
    headers={[
      "Plataforma",
      "O que ele faz",
      "Quais dados são coletados",
      "Como usamos esse cookie",
    ]}
    rows={[
      [
        "Facebook",
        <>
          É a plataforma de publicidade do Facebook e que trabalha na observação
          dos dados de vínculo entre as campanhas veiculadas pela CAIXA
          Consórcio no Facebook para identificar problemas de configuração,
          criar grupos de audiência baseados em comportamentos no site, medir
          performance de campanhas. Mais informações podem ser obtidas na{" "}
          <a
            href="https://www.facebook.com/policies_center/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            página do Facebook.
          </a>
        </>,
        "A plataforma de publicidade do Facebook mapeia as páginas visualizadas por você e anexa esses dados a um identificador da própria plataforma, que faz o vínculo de forma anônima com o seu perfil no Facebook. ",
        <>
          Os cookies gerados pela plataforma são gravados na sessão do navegador
          e são identificados com a inclusão dos termos act, c_user, datr, dpr,
          fr, presence, sb, spin, wd ou xs no seu nome, sendo mantidas no seu
          navegador por um ano. Os cookies são utilizados pelo Facebook para
          vincular as informações da sua navegação e, assim, possibilitar a
          criação de audiências no Facebook, visando à configuração de campanhas
          de marketing direcionadas para o público, medição de performance das
          campanhas realizadas e remarketing aplicado a dispositivos que
          realizaram conversões nas campanhas de marketing realizadas.
        </>,
      ],
      [
        "Google Marketing Platform",
        <>
          É a plataforma de publicidade do Google, composta pelas ferramentas
          Google Campaign Manager e Google Display Video, Google Ads, que
          trabalham na observação dos dados de vínculo entre as campanhas
          veiculadas pela Caixa Consórcio no Google para identificar problemas
          de configuração, criar grupos de audiência baseados em comportamentos
          no site, medir performance de campanhas. Mais informações podem ser
          obtidas na{" "}
          <a
            href="https://policies.google.com/technologies/ads"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            página do Google.
          </a>
        </>,
        "A plataforma de publicidade do Google mapeia as páginas visualizadas por você e anexa esses dados a um identificador deles, que faz o vínculo de forma anônima com o seu dispositivo.                            A plataforma de marketing do Google expande também o uso do Google Analytics para mapear audiências para as campanhas baseadas nos dados de navegação dos dispositivos em nosso site. ",
        <>
          Os cookies gerados pela plataforma são gravados na sessão do navegador
          e são identificados com a inclusão dos termos gads, dsid, ide,
          test_cookie ou aid no seu nome, sendo mantidos no seu navegador por um
          ano. Os cookies são utilizados pelo Google para vincular as
          informações da sua navegação e assim possibilitar a criação de
          audiências no Google Display Video e Google Ads, visando à
          configuração de campanhas de marketing direcionadas para o público,
          medição de performance das campanhas realizadas e remarketing aplicado
          a dispositivos que realizaram conversões nas campanhas de marketing
          realizadas.
        </>,
      ],
      [
        "Adobe Audience Manager",
        <>
          É a plataforma de administração de dados da Adobe, que usamos para
          administrar dados de audiências acionáveis em campanhas de marketing,
          trabalhando com o controle de toda a geração dos dados e com a
          administração dos segmentos de audiência baseados nas informações
          captadas.Mais informações podem ser obtidas{" "}
          <a
            href="https://business.adobe.com/br/products/audience-manager/adobe-audience-manager.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            na página da Adobe sobre o Audience Manager{" "}
          </a>{" "}
          e no aviso de privacidade de dados.
        </>,
        "A plataforma da Adobe faz uma captação automática de informações referentes à página que está sendo visualizada por você e informações sobre o dispositivo de acesso, o restante do trabalho é feito de forma receptiva, aguardando que a CAIXA Consórcio determine quais dados são relevantes para a geração dos segmentos de audiência. Dentro desse contexto, nós trabalhamos com envio de informações sobre produtos visualizados, existência de produtos contratados por tipo de produto, dados demográficos, vínculo do dispositivo com o cliente, cliques e ações nas páginas do site, dados da origem de seu acesso, cruzamento de campanhas de mídia, localização do dispositivo através da base de IP, dados preenchidos em formulários como o tipo de produto escolhido, valores contratados, sexo, idade e localidade.",
        "Os cookies gerados pela plataforma são gravados na sessão do navegador e são identificados com a inclusão do termo aam no seu nome, sendo mantidos no navegador por 30 dias Os cookies são utilizados pela Adobe para vincular as informações enviadas com o dispositivo, visando a criar uma base de informações, sobre o dispositivo, que possibilite o acionamento em campanhas de marketing baseadas nos dados captados e segmentados. Esse acionamento é feito de forma anônima, todo o tratamento de informações na plataforma leva em conta os segmentos criados, que sempre contêm grupos maiores de usuários, o que impossibilita a sua identificação pessoal, mas permite que o seu dispositivo seja impactado por mídias.",
      ],
      [
        "Interações com Campanhas",
        "É um serviço interno da Caixa Consórcio que faz o mapeamento da navegação do dispositivo em conjunto com as nossas campanhas de marketing, visando a ter informações sobre as ações realizadas por você, com o objetivo de criar um modelo de atribuição das conversões realizadas, apresentando a participação das campanhas no processo de aquisição de novos clientes. ",
        "Esse serviço capta dados específicos dos impactos e das suas interações com as campanhas de marketing da Caixa Consórcio, obtendo os dados de qual campanha você visualizou, em qual clicou e mapeando em conjunto os dados das ações realizadas em nosso site dentro do contexto da campanha. ",
        <>
          Esse serviço usa o cookie gerado com a identificação do dispositivo, é
          armazenado de forma permanente no localStorage do navegador, com o
          nome csDataLayer, e tem duração por prazo indefinido.
          <br />
          <br />O cookie é utilizado para vincular os dados captados dos
          impactos e das interações com as campanhas no dispositivo e assim
          armazenar na base de dados da Caixa Consórcio.
        </>,
      ],
    ]}
  />
);

const customTableCookiesAnaliticos = (
  <CustomTable
    headers={[
      "Plataforma",
      "O que ele faz",
      "Quais dados são coletados",
      "Como usamos esse cookie",
    ]}
    rows={[
      [
        "Google Analytics",
        <>
          É uma plataforma de análise de dados da sua navegação no site. Ela
          permite interpretar, de forma anônima, a utilização e a interação dos
          usuários com o nosso site. Mais informações{" "}
          <a
            href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            página do Google Analytics.
          </a>
        </>,
        "Essa plataforma capta dados específicos da navegação do usuário no nosso site, como hora de entrada, hora de saída, páginas visitadas, cliques e ações efetuadas, os dados da origem de seu acesso e cruzamento de campanhas de mídia",
        <>
          Os cookies gerados pela plataforma são gravados na sessão do navegador
          e são identificados com a inclusão do termo ga no seu nome, parte dos
          cookies que são destinados à identificação do dispositivo é mantida
          por um prazo de 2 anos e outra parte, de identificação da sessão, é
          mantida por 30 minutos.
        </>,
      ],
      [
        "Hotjar",
        <>
          É uma plataforma que nos ajuda a entender melhor a sua experiência no
          uso dos nossos serviços, permitindo analisar as funcionalidades e as
          informações na{" "}
          <a
            href="https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookies"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            página da Hotjar.
          </a>
        </>,
        "Essa plataforma capta dados específicos da sua navegação no nosso site como páginas visitadas, cliques e ações efetuados e trechos de conteúdos visualizados.",
        <>
          Os cookies gerados pela plataforma são armazenados de forma permanente
          no localStorage do navegador com as chaves que contêm no nome o valor
          hj, e têm duração de um ano. Outros cookies armazenados em sua sessão
          também são utilizados, e são identificados por conter o termo hj no
          nome. São excluídos após o fechamento do navegador.
        </>,
      ],
      [
        "Navegação do dispositivo",
        "É um serviço interno da CAIXA Consórcio que faz o mapeamento de toda a jornada de navegação do dispositivo no nosso site, visando a ter informações sobre o seu comportamento no uso do site, dos nossos serviços online e dos serviços de compra de produtos. Usamos para ter um cruzamento anônimo da performance de cada produto dentro dos nossos canais.",
        "Esse serviço capta dados específicos da sua navegação em nosso site, como hora de entrada, hora de saída, páginas visitadas, cliques e ações efetuadas, os dados da origem de seu acesso, cruzamento de campanhas de mídia, localização do dispositivo através da base de IP, dados anônimos preenchidos em formulários, como o tipo de produto escolhido, valores contratados e características demográficas usadas apenas para análise de performance de produtos.",
        "Esse serviço usa o cookie gerado como a identificação do dispositivo, que é armazenado de forma permanente no localStorage do navegador, com o nome csDataLayer, e tem duração por prazo indefinido. Ele é utilizado para vincular os dados captados da navegação do usuário com o dispositivo e assim armazenar na base de dados da CAIXA Consórcio.",
      ],
    ]}
  />
);

const customTableCookiesPlataforma = (
  <CustomTable
    headers={[
      "Plataforma",
      "O que ele faz",
      "Quais dados são coletados",
      "Como usamos esse cookie",
    ]}
    rows={[
      [
        "Google Tag Manager ",
        <>
          É uma plataforma de gestão de tags que permite a implementação e a
          atualização de tags e snippets de código no website de forma rápida,
          através de uma só interface. Essa plataforma não acessa dados
          pessoais, apenas controla a inclusão de outras tags que podem
          administrar seus dados e do dispositivo, tratadas em tópicos dedicados
          nesta Política. Mais informações na{" "}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://marketingplatform.google.com/intl/pt-BR_br/about/tag-manager/"
          >
            página do Google Tag Manager
          </a>
          .
        </>,
        "Essa plataforma não capta nenhum cookie e nenhum dado seu, não tendo, para o seu funcionamento, nenhuma informação pessoal sua captada. ",
        <>
          Os cookies gerados pela plataforma são gravados na sessão do navegador
          e são identificados com a inclusão do termo gtm no seu nome, sendo
          excluídos quando o navegador é fechado. Eles são utilizados
          exclusivamente para vincular informações do dispositivo com os dados
          do{" "}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://policies.google.com/technologies/cookies"
          >
            Google Tag Manager
          </a>
          , sem caráter analítico das informações, apenas para funcionamento
          técnico da plataforma.
        </>,
      ],
      [
        "Identificação do dispositivo ",
        "É um serviço interno nosso que identifica quando você acessa os nossos serviços e sites pela primeira vez, gerando um identificador único desse dispositivo de acesso. ",
        "Esse processo capta diversas informações do dispositivo, com o objetivo de criar o identificador único. São tratados apenas dados anônimos do dispositivo, como o tipo do navegador, plugins instalados no navegador, driver de áudio instalado, capacidade de memória do dispositivo, fabricante do dispositivo, versões de sistema e navegador. ",
        "O cookie gerado com a identificação do dispositivo é armazenado de forma permanente no localStorage do navegador, com o nome cnpData, e tem duração por prazo indefinido. Ele é utilizado para a centralização do aceite da política de cookies do site e como identificação de todos os dados captados após a sua permissão. ",
      ],
      [
        "Geolocation ",
        "É um serviço interno nosso que identifica quando você acessa os nossos serviços e sites, momento em que analisamos o endereço IP da origem do acesso para localizar o país de acesso ao site.  ",
        "Esse método de busca dos dados de geolocalização não é preciso ou invasivo, trabalha baseado em dados públicos sobre os endereços de IP fornecidos pelos provedores de acesso à internet.  ",
        "O cookie gerado com a localização do dispositivo é armazenado de forma permanente no localStorage do navegador, com o nome cnpData, e tem duração por prazo indefinido. Ele é utilizado como parte do processo de identificação única do dispositivo, necessário para o processo de apuração das definições quanto à autorização para o uso de cookies por você no dispositivo.  ",
      ],
    ]}
  />
);

export const ItensPoliticaCookies = [
  {
    question: "O que são cookies?",
    answers: [
      {
        text: `
          Cookies são pedaços de informações armazenadas 
          diretamente em seu dispositivo quando você entra 
          em nossos sites ou aplicativos. Ao acessá-los, 
          você pode escolher quais categorias de cookies 
          deseja permitir. Os cookies nos ajudam a entender 
          melhor seu comportamento e suas preferências para 
          disponibilizarmos produtos de acordo com o seu perfil.
        `,
        type: "default",
      },
    ],
    showDefault: true,
  },
  {
    question: "Quais cookies utilizamos e como utilizamos?",
    answers: [
      {
        text: (
          <>
            <b>Cookies essenciais</b>
          </>
        ),
        type: "default",
      },
      {
        text: `
          Os cookies essenciais já são inclusos e ativos a partir
          do primeiro momento em que você entra no nosso site.
          Eles servem para você conseguir navegar sem
          complicações. Além deles, escolha quais outros tipos de
          cookies podemos utilizar.
        `,
        type: "default",
      },
      {
        text: (
          <>
            <b>Cookies analíticos</b>
          </>
        ),
        type: "default",
      },
      {
        text: `
          Para entender melhor o seu comportamento e analisar os
          dados sobre as ações tomadas no site, com o objetivo de
          verificar a performance dos nossos produtos.
        `,
        type: "default",
      },
      {
        text: (
          <>
            <b>Cookies de marketing</b>
          </>
        ),
        type: "default",
      },
      {
        text: `
          Para mapear sua jornada de compra, possibilitando o uso
          desses dados para te oferecer produtos de forma
          personalizada.
        `,
        type: "default",
      },
    ],
    showDefault: true,
  },
  {
    question: "Cookies essenciais",
    answers: [
      {
        text: `
          Esses tipos de cookies são essenciais para o
          funcionamento de nosso site e não é possível
          desativá-los. São divididos em cookies de autenticação,
          que auxiliam nossos sistemas a saberem que você é você
          mesmo, e cookies técnicos, necessários para que as
          funcionalidades do site estejam disponíveis. Ao clicar
          nas opções abaixo, você pode ver os detalhes sobre esses
          cookies.
        `,
        type: "default",
      },
      {
        text: (
          <>
            <b style={{ fontSize: "2em" }}>Cookies de autenticação</b>
          </>
        ),
        type: "default",
      },
      {
        text: customTableCookiesPlataforma,
        type: "default",
      },
      {
        text: (
          <>
            <b style={{ fontSize: "2em" }}>Cookies técnicos</b>
          </>
        ),
        type: "default",
      },
      {
        text: customTableCookiesPlataforma,
        type: "default",
      },
    ],
    showDefault: true,
  },
  {
    question: "Cookies analíticos",
    answers: [
      {
        text: `
          De uso exclusivamente interno, os cookies analíticos nos
          ajudam a perceber como podemos melhorar os serviços que
          prestamos a você. Eles se limitam a avaliar como você
          interage com o nosso site enquanto navega, de maneira
          anônima, procurando a entender como melhorar sua
          experiência com a gente na hora de falar com você.
        `,
        type: "default",
      },
      {
        text: customTableCookiesAnaliticos,
        type: "default",
      },
    ],
    showDefault: true,
  },
  {
    question: "Cookies de marketing",
    answers: [
      {
        text: `
          Esses cookies utilizam informações sobre a sua navegação
          para trazer a publicidade mais relevante a você,
          personalizada para suas necessidades.
        `,
        type: "default",
      },
      {
        text: `
          Também são empregados para limitar a sua visualização de
          anúncios e ajudar a avaliar a eficácia das campanhas de
          marketing da Caixa Consórcio. Eles são colocados por
          redes publicitárias de terceiros em nome e com permissão
          da companhia.`,
        type: "default",
      },
      {
        text: `
          Eles identificam também que você visitou sites da
          empresa e Eles identificam também que você visitou sites
          da empresa e de qual endereço você veio. Essa informação
          pode ser compartilhada com fornecedores de mídia para
          que anúncios sejam apresentados a você em outras
          páginas, caso a gente entenda que você tem interesse, e
          para remunerar parceiros que apresentam publicidade CNP
          Capitalização.`,
        type: "default",
      },
      {
        text: `
          Eventualmente, algum novo cookie pode estar ativo em
          sites da companhia e ainda não terem sido atualizados
          nesta política. Todos os cookies de marketing, porém,
          dependem de seu consentimento, cujas opções você sempre
          pode rever.`,
        type: "default",
      },
      {
        text: customTableCookiesMarketing,
        type: "default",
      },
    ],
    showDefault: true,
  },
];
